<app-base-modal
  [title]="declarationResourceType.name"
  [showStateToggle]="isValid"
>
  <div class="wrapper">
    <mat-accordion [multi]="true">
      @for (declaration of declarationsData; track $index) {
        <mat-expansion-panel [expanded]="declaration.id === 0">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div class="title">
                <div class="title-text">
                  {{ declaration.declarationNumber }}
                </div>
                @if (!!declaration.id && isEditModeActive) {
                  <button
                    mat-mini-fab
                    class="btn-delete"
                    (click)="handleDelete($event, declaration.id, $index)"
                  >
                    <mat-icon class="btn-delete-icon">delete</mat-icon>
                  </button>
                }
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
            <app-declaration-form
              [parentId]="declarationDialogData.parentId"
              [declarationData]="declaration"
              [declarationFormGroup]="declarationFormGroups[$index]"
              [noFirstData]="noFirstData"
              [isEditModeActive]="isEditModeActive"
              (updateDeclarationData)="updateDeclarationData($event, $index)"
              (deleteDeclaration)="deleteDeclaration($index)"
            />
            @if (declaration.id) {
              <div
                app-declaration-files
                [declarationId]="declaration.id"
                [isEditModeActive]="isEditModeActive"
                class="declaration-files"
              ></div>
            }
        </mat-expansion-panel>
      }
    </mat-accordion>
  </div>
  <div class="buttons-container">
    <button
      mat-button
      color="warn"
      type="button"
      (click)="closeDialog('cancel')"
    >
      Закрыть
    </button>
    <button
      mat-button
      color="primary"
      type="button"
      [disabled]="!isValid"
      (click)="handleAddNew()"
    >
      Добавить новую
    </button>
  </div>
</app-base-modal>
